import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const COMMENTS_REQUEST = 'COMMENTS_REQUEST';
export const COMMENTS_SUCCESS = 'COMMENTS_SUCCESS';
export const COMMENTS_FAILURE = 'COMMENTS_FAILURE';

export const COMMENT_ADD_REQUEST = 'COMMENT_ADD_REQUEST';
export const COMMENT_ADD_SUCCESS = 'COMMENT_ADD_SUCCESS';
export const COMMENT_ADD_FAILURE = 'COMMENT_ADD_FAILURE';

export const COMMENT_UPDATE_REQUEST = 'COMMENT_UPDATE_REQUEST';
export const COMMENT_UPDATE_SUCCESS = 'COMMENT_UPDATE_SUCCESS';
export const COMMENT_UPDATE_FAILURE = 'COMMENT_UPDATE_FAILURE';

export const COMMENT_DELETE_REQUEST = 'COMMENT_DELETE_REQUEST';
export const COMMENT_DELETE_SUCCESS = 'COMMENT_DELETE_SUCCESS';
export const COMMENT_DELETE_FAILURE = 'COMMENT_DELETE_FAILURE';

export const PATIENT_COMMENTS_REQUEST = 'PATIENT_COMMENTS_REQUEST';
export const PATIENT_COMMENTS_SUCCESS = 'PATIENT_COMMENTS_SUCCESS';
export const PATIENT_COMMENTS_FAILURE = 'PATIENT_COMMENTS_FAILURE';

export const PATIENT_COMMENT_ADD_REQUEST = 'PATIENT_COMMENT_ADD_REQUEST';
export const PATIENT_COMMENT_ADD_SUCCESS = 'PATIENT_COMMENT_ADD_SUCCESS';
export const PATIENT_COMMENT_ADD_FAILURE = 'PATIENT_COMMENT_ADD_FAILURE';

export const PATIENT_COMMENT_UPDATE_REQUEST = 'PATIENT_COMMENT_UPDATE_REQUEST';
export const PATIENT_COMMENT_UPDATE_SUCCESS = 'PATIENT_COMMENT_UPDATE_SUCCESS';
export const PATIENT_COMMENT_UPDATE_FAILURE = 'PATIENT_COMMENT_UPDATE_FAILURE';

export const PATIENT_COMMENT_DELETE_REQUEST = 'PATIENT_COMMENT_DELETE_REQUEST';
export const PATIENT_COMMENT_DELETE_SUCCESS = 'PATIENT_COMMENT_DELETE_SUCCESS';
export const PATIENT_COMMENT_DELETE_FAILURE = 'PATIENT_COMMENT_DELETE_FAILURE';

export const ESCALATION_COMMENTS_REQUEST = 'ESCALATION_COMMENTS_REQUEST';
export const ESCALATION_COMMENTS_SUCCESS = 'ESCALATION_COMMENTS_SUCCESS';
export const ESCALATION_COMMENTS_FAILURE = 'ESCALATION_COMMENTS_FAILURE';

export const PATIENT_ESCALATION_COMMENTS_REQUEST = 'PATIENT_ESCALATION_COMMENTS_REQUEST';
export const PATIENT_ESCALATION_COMMENTS_SUCCESS = 'PATIENT_ESCALATION_COMMENTS_SUCCESS';
export const PATIENT_ESCALATION_COMMENTS_FAILURE = 'PATIENT_ESCALATION_COMMENTS_FAILURE';

export const LOCATION_ESCALATION_COMMENTS_REQUEST = 'LOCATION_ESCALATION_COMMENTS_REQUEST';
export const LOCATION_ESCALATION_COMMENTS_SUCCESS = 'LOCATION_ESCALATION_COMMENTS_SUCCESS';
export const LOCATION_ESCALATION_COMMENTS_FAILURE = 'LOCATION_ESCALATION_COMMENTS_FAILURE';

export function requestClientComments(employerCodeNumber, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/client/${employerCodeNumber}/comments?${query}`,
      method: 'GET',
      types: ["COMMENTS_REQUEST", "COMMENTS_SUCCESS", "COMMENTS_FAILURE"]
    },
  };
}

export function addClientComment(message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/comment/add?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["COMMENT_ADD_REQUEST", "COMMENT_ADD_SUCCESS", "COMMENT_ADD_FAILURE"]
    }
  }
}

export function updateClientComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/comment/update/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["COMMENT_UPDATE_REQUEST", "COMMENT_UPDATE_SUCCESS", "COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deleteClientComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/comment/delete/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(id),
      types: ["COMMENT_DELETE_REQUEST", "COMMENT_DELETE_SUCCESS", "COMMENT_DELETE_FAILURE"]
    }
  }
}

export function requestPatientComments(masterPatientId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/${masterPatientId}/comments?${query}`,
      method: 'GET',
      types: ["PATIENT_COMMENTS_REQUEST", "PATIENT_COMMENTS_SUCCESS", "PATIENT_COMMENTS_FAILURE"]
    },
  };
}

export function addPatientComment(message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/comment/add?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["PATIENT_COMMENT_ADD_REQUEST", "PATIENT_COMMENT_ADD_SUCCESS", "PATIENT_COMMENT_ADD_FAILURE"]
    }
  }
}

export function updatePatientComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/comment/update/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["PATIENT_COMMENT_UPDATE_REQUEST", "PATIENT_COMMENT_UPDATE_SUCCESS", "PATIENT_COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deletePatientComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/comment/delete/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(id),
      types: ["PATIENT_COMMENT_DELETE_REQUEST", "PATIENT_COMMENT_DELETE_SUCCESS", "PATIENT_COMMENT_DELETE_FAILURE"]
    }
  }
}

export function requestClientEscalationComments(escalationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/escalation/${escalationId}/comments?${query}`,
      method: 'GET',
      types: ["ESCALATION_COMMENTS_REQUEST", "ESCALATION_COMMENTS_SUCCESS", "ESCALATION_COMMENTS_FAILURE"]
    },
  };
}

export function addClientEscalationComment(message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/escalation/comment/add?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["ESCALATION_COMMENT_ADD_REQUEST", "ESCALATION_COMMENT_ADD_SUCCESS", "ESCALATION_COMMENT_ADD_FAILURE"]
    }
  }
}

export function updateClientEscalationComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/escalation/comment/update/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["ESCALATION_COMMENT_UPDATE_REQUEST", "ESCALATION_COMMENT_UPDATE_SUCCESS", "ESCALATION_COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deleteClientEscalationComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/escalation/comment/delete/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(id),
      types: ["ESCALATION_COMMENT_DELETE_REQUEST", "ESCALATION_COMMENT_DELETE_SUCCESS", "ESCALATION_COMMENT_DELETE_FAILURE"]
    }
  }
}

export function requestPatientEscalationComments(escalationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/escalation/${escalationId}/comments?${query}`,
      method: 'GET',
      types: ["PATIENT_ESCALATION_COMMENTS_REQUEST", "PATIENT_ESCALATION_COMMENTS_SUCCESS", "PATIENT_ESCALATION_COMMENTS_FAILURE"]
    },
  };
}

export function addPatientEscalationComment(message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/escalation/comment/add?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["PATIENT_ESCALATION_COMMENT_ADD_REQUEST", "PATIENT_ESCALATION_COMMENT_ADD_SUCCESS", "PATIENT_ESCALATION_COMMENT_ADD_FAILURE"]
    }
  }
}

export function updatePatientEscalationComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/escalation/comment/update/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["PATIENT_ESCALATION_COMMENT_UPDATE_REQUEST", "PATIENT_ESCALATION_COMMENT_UPDATE_SUCCESS", "PATIENT_ESCALATION_COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deletePatientEscalationComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patient/escalation/comment/delete/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(id),
      types: ["PATIENT_ESCALATION_COMMENT_DELETE_REQUEST", "PATIENT_ESCALATION_COMMENT_DELETE_SUCCESS", "PATIENT_ESCALATION_COMMENT_DELETE_FAILURE"]
    }
  }
}

export function requestLocationEscalationComments(escalationId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/location-escalation/${escalationId}/comments?${query}`,
      method: 'GET',
      types: ["LOCATION_ESCALATION_COMMENTS_REQUEST", "LOCATION_ESCALATION_COMMENTS_SUCCESS", "LOCATION_ESCALATION_COMMENTS_FAILURE"]
    },
  };
}

export function addLocationEscalationComment(message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/location-escalation/comment/add?${query}`,
      method: 'POST',
      body: JSON.stringify(message),
      types: ["LOCATION_ESCALATION_COMMENT_ADD_REQUEST", "LOCATION_ESCALATION_COMMENT_ADD_SUCCESS", "LOCATION_ESCALATION_COMMENT_ADD_FAILURE"]
    }
  }
}

export function updateLocationEscalationComment(id, message, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/location-escalation/comment/update/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(message),
      types: ["LOCATION_ESCALATION_COMMENT_UPDATE_REQUEST", "LOCATION_ESCALATION_COMMENT_UPDATE_SUCCESS", "LOCATION_ESCALATION_COMMENT_UPDATE_FAILURE"]
    }
  }
}

export function deleteLocationEscalationComment(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/location-escalation/comment/delete/${id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(id),
      types: ["LOCATION_ESCALATION_COMMENT_DELETE_REQUEST", "LOCATION_ESCALATION_COMMENT_DELETE_SUCCESS", "LOCATION_ESCALATION_COMMENT_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/comments/CommentsActions.js